import { render, staticRenderFns } from "./DepositDrafts.vue?vue&type=template&id=1fe53158"
import script from "./DepositDrafts.vue?vue&type=script&lang=js"
export * from "./DepositDrafts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports